export const SERVICE_AREAS_SOURCE_ID = 'serviceAreasSource';
export const SERVICE_AREAS_LAYER_ID = 'serviceAreasLayer';

export const SERVICE_AREAS_OPTIONS_SAT = {
  fillColor: '#ffd65a',
  strokeColor: '#ffd65a',
  strokeOpacity: 1,
  strokeWeight: 1,
};
